import React from 'react';
import {Main} from '../../layouts';
import Container from '../../components/Container';
import {Box, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

const NewsView = () => {


    return (
        <Main>
            <Container>
                <Box>
                    <Grid container spacing={2}>
                        <Grid size={{xs:12, md:6}}>
                            <Box>
                                <Typography variant={'h4'} gutterBottom sx={{fontWeight: 700}}>
                                    About Us
                                </Typography>
                                <Typography component={'p'}>
                                    Headquartered in Austin, Texas Vampire Labs was founded by a team of technological
                                    innovators who share a passion for solving the world energy crisis.
                                    <br/>
                                    <br/>
                                    Vampire Labs is driving energy conservation technology within all electronics and is
                                    dedicating its intellectual resources to eliminating the global problem associated
                                    with vampire energy loss.
                                    <br/>
                                    <br/>
                                    We have numerous active patents for technology that eliminates Vampire Energy Loss
                                    in mobile device battery chargers, external power supplies, and other internal
                                    research and development projects.
                                    <br/>
                                    <br/>
                                    To inquire about licensing opportunities, please contact us here
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid size={{xs:12, md:6}}>
                            <Box maxWidth={500} width={1}>
                                <Box
                                    component={'img'}
                                    src={process.env.PUBLIC_URL + '/austin_sunset.jpg'}
                                    width={1}
                                    height={1}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Main>
    );
};

export default NewsView;